// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { NodeFetchHttpClient as DefaultHttpClient } from "./nodeFetchHttpClient";
